import { LandingPageConfig } from 'rangeConfig/@types';
import aurdalBgImage from '../../views/LandingPage/images/aurdal_landing_bg.jpg';
import aurdalOpenDesignImg from '../../views/LandingPage/images/aurdal-open-design.jpeg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import aurdalGalleryConfig from './aurdalGalleryConfig';

const aurdalLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: aurdalBgImage,
    titleTextColor: '#fff'
  },
  designFromScratch: {
    backgroundColor: '#DEB6B294',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: aurdalOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#E6C6AF',
    galleryConfig: aurdalGalleryConfig
  }
};

export default aurdalLandingPageConfig;
